import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  Spinner,
  Image,
  Loading,
  Button,
  DataTable,
  ButtonGroup,
  Toast,
  Checkbox,
  FormLayout,
  Filters,
  TextField,
  Badge,
  Frame,
  InlineError,
  ChoiceList,
  Thumbnail,
  EmptySearchResult,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import { useRef } from "react";
import emptyListImage from "../../../Assets/Images/emptyList.svg";
import { useNavigate } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import Pagination from "@mui/material/Pagination";
import EllipsisText from "react-ellipsis-text";
import { useParams } from "react-router-dom";
import { CategoriesIcon, EditIcon } from "@shopify/polaris-icons";
import { canEditSessions } from "../../../Helpers";

const Sessions = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const addEditState = useRef("");
  const perPage = 50;
  const [ts, setTs] = useState("");
  const [availability, setAvailability] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [page, setPage] = useState(1);
  const [pageObject, setPageObject] = useState({
    isLoading: true,
    isSaving: false,
    tableItems: [],
    tableTotalPages: 0,
    isListEmpty: false,
  });
  const handleAddSession = () => {
    navigate(`/admin/${props.path}/${id}/sessions/new`);
  };
  const handleAddExistingSession = () => {
    navigate(`/admin/${props.path}/${id}/sessions/new-existing`);
  };
  function handleFiltersQueryChange(queryValue) {
    refBoolPage.current = false;
    setQueryValue(queryValue);
  }
  function handleAvailabilityChange(availability) {
    setAvailability(availability);
  }
  const handleAvailabilityRemove = useCallback(() => setAvailability(""), []);
  const handleQueryValueRemove = useCallback(() => setQueryValue(""), []);
  const handleFiltersClearAll = useCallback(() => {
    handleAvailabilityRemove();
    handleQueryValueRemove();
  }, [handleAvailabilityRemove, handleQueryValueRemove]);

  const filters = [
    {
      key: "availability",
      label: "Filter by",
      filter: (
        <ChoiceList
          title="Filter by"
          titleHidden
          choices={[{ label: "Title", value: "title" }]}
          selected={availability || []}
          onChange={handleAvailabilityChange}
        />
      ),
      shortcut: false,
    },
  ];

  const appliedFilters = [];
  if (!isEmpty(availability)) {
    const key = "availability";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, availability),
      onRemove: handleAvailabilityRemove,
    });
  }
  const loadingMarkup = pageObject.isLoading ? <Loading /> : null;
  const emtyState = pageObject.isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "middle",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <Image src={emptyListImage}></Image>
      </div>
      <div className="mb-3">
        <Text variant="bodyLg" as="p">
          No results found
        </Text>
      </div>
      <br />
    </div>
  ) : (
    pageObject.isLoading && (
      <div className="spinnerContainer">
        <div className="vertical-center">
          <Spinner size="large" />
        </div>
      </div>
    )
  );
  const refBoolPage = useRef(true);
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };
  const handleEdit = (param, eventId) => {
    window.open(`/admin/${props?.path}/${id}/sessions/${param}`, "_blank");
    // navigate(`/admin/${props?.path}/${id}/sessions/${param}`);
    // eventId !== null
    // ? window.open(
    //     `/admin/${props?.path}/${id}/sessions/existing/${param}`,
    //     "_blank"
    //   )
    //   : window.open(`/admin/${props?.path}/${id}/sessions/${param}`, "_blank");
  };
  const handleBookings = (param) => {
    // navigate(`/admin/${props?.path}/${id}/sessions/${param}/bookings`);
    window.open(
      `/admin/${props?.path}/${id}/sessions/${param}/bookings`,
      "_blank"
    );
  };
  useEffect(() => {
    fetchData();
  }, [ts, availability, queryValue, page]);

  async function fetchData() {
    let responseSessions = "";

    try {
      responseSessions = await axios.get(
        `/${
          props?.is_course === "yes" ? "courses" : "classes"
        }/${id}/sessions?per_page=${perPage}&page=${
          refBoolPage.current ? page : 1
        }`
      );
      setPageObject({
        ...pageObject,
        tableItems: responseSessions.data.data.data.map((item, index) => [
          props?.path === "classes"
            ? item?.date
              ? item.date
              : "-"
            : item?.date
            ? item.date
            : "-",

          props?.path === "events" ? (item?.to_date ? item.to_date : "-") : "",
          props?.is_course === "yes"
            ? item?.start_time
              ? item.start_time
              : "-"
            : item?.launch_time
            ? item.launch_time
            : "-",
          props?.is_course === "yes"
            ? item?.end_time
              ? item.end_time
              : "-"
            : item?.finish_time
            ? item.finish_time
            : "-",
          props?.path === "classes"
            ? item?.instructor !== null && item?.instructor?.name
              ? item?.instructor?.name
              : "-"
            : item?.instructors !== null && item?.instructors?.length
            ? item.instructors.map((item) => item.name).join(", ")
            : "-",
          <Badge tone={item.is_active ? "success" : "info"}>
            {item.is_active ? "Active" : "Draft"}
          </Badge>,
          <ButtonGroup>
            <Button
              onClick={() => handleBookings(item.id)}
              icon={CategoriesIcon}
              disabled={!canEditSessions}
            >
              Bookings
            </Button>

            <Button
              onClick={() => handleEdit(item.id, item.event_id)}
              icon={EditIcon}
              disabled={item.is_edit_disabled}
            >
              Edit
            </Button>
          </ButtonGroup>,
        ]),
        isLoading: false,
        isListEmpty: !responseSessions.data.data.data.length ? true : false,
        tableTotalPages: responseSessions.data.data.total,
      });
    } catch (error) {
      console.log(error);
    }

    // if (!featuresList.length)
    //   try {
    //     responseFeatures = await axios.get(`features`);
    //     setFeaturesList(
    //       responseFeatures.data.data.data.map((item, index) => {
    //         return {
    //           label: item.name,
    //           value: item.id,
    //         };
    //       })
    //     );
    //   } catch (error) {
    //     console.log(error);
    //   }
  }

  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "This professor has been successfully deleted"
  );

  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;

  return (
    <Page
      fullWidth
      title="Sessions"
      primaryAction={
        <ButtonGroup>
          <Button
            variant="primary"
            onClick={handleAddSession}
            disabled={!canEditSessions || props?.is_course === "yes"}
          >
            {props.path === "events" ? `Add New Session` : `Add Session`}
          </Button>
          {props.path === "events" ? (
            <Button
              variant="primary"
              onClick={handleAddExistingSession}
              disabled={!canEditSessions}
            >
              Add Existing Session
            </Button>
          ) : null}
        </ButtonGroup>
      }
      backAction={{ onAction: () => navigate(`/admin/${props.path}`) }}
    >
      <Card padding="0">
        {loadingMarkup}

        {/* <Filters
          queryValue={queryValue}
          queryPlaceholder="Search..."
          filters={filters}
          appliedFilters={appliedFilters}
          onQueryChange={handleFiltersQueryChange}
          onQueryClear={handleQueryValueRemove}
          onClearAll={handleFiltersClearAll}
        /> */}

        <DataTable
          columnContentTypes={["text", "text", "text", "text"]}
          headings={[
            <Text variant="bodyMd" as="p" fontWeight="medium">
              {props?.path === "events" ? "Start Date" : "Date"}
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              {props?.path === "events" ? "End Date" : ""}
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Start Time
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              End Time
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              {props?.path === "events" || props?.is_course === "yes"
                ? "Instructors"
                : "Instructor"}
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
          ]}
          rows={pageObject.tableItems}
          verticalAlign="middle"
          increasedTableDensity
          footerContent={
            pageObject.tableItems?.length &&
            `Showing ${pageObject.tableItems.length} of ${pageObject.tableTotalPages} results`
          }
          hasZebraStripingOnData
        />
        {emtyState}
        {Math.ceil(pageObject.tableTotalPages / perPage) >= 2 && (
          <div
            style={{
              paddingTop: "10px",
              textAlign: "center",
              paddingBottom: "10px",
            }}
          >
            <Pagination
              variant="outlined"
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
            />
            {/* <Pagination
              count={Math.ceil(pageObject.tableTotalPages / perPage)}
              page={page}
              onChange={handleChangePage}
              size="large"
            /> */}
          </div>
        )}

        {toastMarkup}
      </Card>
    </Page>
  );
  function disambiguateLabel(key, value) {
    switch (key) {
      case "taggedWith":
        return `Tagged with ${value}`;
      case "availability":
        return `Filter by ${value}`;
      default:
        return value;
    }
  }
  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
  function getFirstNonNullValue(obj) {
    for (const value of Object.values(obj)) {
      if (value !== null) {
        return value;
      }
    }
    return null;
  }
};

export default Sessions;
